interface CustomCellProps {
  key: string
  value: Record<string, string> | undefined
  isExpanded: boolean
  setExpanded: (isExpanded: boolean) => void
}

export const CustomCell = (props: CustomCellProps) => {
  if (!props.value) {
    return <td key={props.key}></td>
  } else if (!props.isExpanded) {
    return (
      <td key={props.key}>
        <span onClick={() => props.setExpanded(true)}>{Object.keys(props.value).length} entries...</span>
      </td>
    )
  } else {
    return (
      <td key={props.key} onClick={() => props.setExpanded(false)}>
        <div className={'flex flex-col'}>
          {Object.entries(props.value).map(([key, value]) => {
            return (
              <div key={`${props.key}--${key}`}>
                {key}: {value}
              </div>
            )
          })}
        </div>
      </td>
    )
  }
}
